function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC917"
    },
    d: "M261.333,245.333v-64c11.396,0,22.114-4.437,30.17-12.497c8.06-8.064,12.497-18.773,12.497-30.17 s-4.437-22.114-12.501-30.174C283.443,100.437,272.73,96,261.333,96H58.667V32h202.667c28.493,0,55.279,11.098,75.422,31.241 C356.907,83.392,368,110.178,368,138.667s-11.098,55.275-31.241,75.422C316.612,234.236,289.826,245.333,261.333,245.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAC917"
    },
    d: "M261.333,394.667H58.667v-64h202.667c11.396,0,22.114-4.437,30.17-12.497 C299.563,310.106,304,299.396,304,288c0-11.396-4.437-22.114-12.501-30.174c-8.055-8.055-18.769-12.493-30.165-12.493H112v-64 h149.333c28.493,0,55.279,11.098,75.422,31.241C356.907,232.725,368,259.511,368,288c0,28.489-11.098,55.275-31.241,75.422 C316.612,383.569,289.826,394.667,261.333,394.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 64,
    style: {
      fill: "#FAC917"
    },
    width: 64,
    height: 298.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.437,
    style: {
      fill: "#FAC917"
    },
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.875,
    style: {
      fill: "#FAC917"
    },
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.437,
    y: 362.667,
    style: {
      fill: "#FAC917"
    },
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.875,
    y: 362.667,
    style: {
      fill: "#FAC917"
    },
    width: 64,
    height: 64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.01f1cd53abd388f460dd46f7b3429d48.svg";
export { ForwardRef as ReactComponent };